import { Injectable } from '@angular/core';
import { TransferOrderToXLS, SourceAccount, TransferOrder } from '../interfaces/all';

@Injectable({
  providedIn: 'root'
})
export class MaritimebankService implements TransferOrderToXLS {

  constructor() { }

  private extractXLS(source: SourceAccount, data: Array<TransferOrder>): Array<object> {

    let xls = [];

    for (let i = 0; i < data.length; i++) {
      xls.push({
        'STT': i + 1,
        'Loại giao dịch': data[i].internal ? '1. Chuyển khoản nội bộ MSB' : '2. Chuyển khoản liên ngân hàng',
        'Tài khoản nguồn': source.account,
        'Tài khoản thụ hưởng': data[i].target.account,
        'Tên người thụ hưởng': data[i].target.owner,
        'Mã chi nhánh Ngân hàng thụ hưởng': data[i].target.code,
        'Số tiền': Math.round(data[i].amount),
        'Diễn giải': data[i].notes
      });
    }

    return xls;
  }

  public extractExternalXLS = this.extractXLS;
  public extractInternalXLS = this.extractXLS;
}
